import { render, staticRenderFns } from "./InterviewsDCNewComponents.vue?vue&type=template&id=23b628d4&scoped=true&"
import script from "./InterviewsDCNewComponents.vue?vue&type=script&lang=js&"
export * from "./InterviewsDCNewComponents.vue?vue&type=script&lang=js&"
import style0 from "./InterviewsDCNewComponents.vue?vue&type=style&index=0&id=23b628d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b628d4",
  null
  
)

export default component.exports